var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.active)?_c('div',{staticClass:"loading",class:[{ slim: _vm.slim }, _vm.site]},[_c('div',{staticClass:"loader"}),_c('div',{staticClass:"loading-message"},[_vm._v(_vm._s(_vm.message))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }